import React, { useState, useEffect } from 'react';
import HelpBallon from '../../Intelligence/component/HelpBalloon/HelpBalloon';

export default (props) => {
  const { doUpdateItem, item } = props;
  const [quickAccessCheck, setQuickAccessCheck] = useState(
    item?.quickAccess || false
  );

  useEffect(() => {
    if (item) {
      setQuickAccessCheck(item.quickAccess || false);
    }
  }, [item]);

  const handleToggleQuickAccess = (event) => {
    const { checked } = event.target;
    setQuickAccessCheck(checked);
    doUpdateItem({ quickAccess: checked });
  };

  return (
    <>
      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            id="quickAccess"
            checked={quickAccessCheck}
            onChange={handleToggleQuickAccess}
          />
          <label
            className="custom-control-label quickAccess-label"
            htmlFor="quickAccess"
          >
            Acesso Rápido
          </label>

          <HelpBallon
            id="help-ballon-check-agente"
            message="Se ativo, o bloco é listado em acesso rápido."
          />
        </div>
      </div>
    </>
  );
};
